import { WebLayout } from "components/Layout";
import { motion } from "framer-motion";
import { useMemo, useState, useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight, Grid } from "react-feather";
import image1 from "assets/gallery/image_1.jpeg";
import image2 from "assets/gallery/image_2.jpeg";
import image3 from "assets/gallery/image_3.jpeg";
import image4 from "assets/gallery/image_4.jpeg";
import image5 from "assets/gallery/image_5.jpeg";
import image6 from "assets/gallery/image_6.jpeg";
import image7 from "assets/gallery/image_7.jpeg";
import image8 from "assets/gallery/image_8.jpeg";
import image9 from "assets/gallery/image_9.jpeg";
import image10 from "assets/gallery/image_10.jpeg";
import image11 from "assets/gallery/image_11.jpeg";
import image12 from "assets/gallery/image_12.jpeg";
import image13 from "assets/gallery/image_13.jpeg";
import image14 from "assets/gallery/image_14.jpeg";
import image15 from "assets/gallery/image_15.jpeg";
import image16 from "assets/gallery/image_16.jpeg";
import image17 from "assets/gallery/image_17.jpeg";
import image18 from "assets/gallery/image_18.jpeg";
import image19 from "assets/gallery/image_19.jpeg";
import image20 from "assets/gallery/image_20.jpeg";
import image21 from "assets/gallery/image_21.jpeg";
import image22 from "assets/gallery/image_22.jpeg";
import image23 from "assets/gallery/image_23.jpeg";
import image24 from "assets/gallery/image_24.jpeg";
import image25 from "assets/gallery/image_25.jpeg";
import image26 from "assets/gallery/image_26.jpeg";
import image27 from "assets/gallery/image_27.jpeg";
import image28 from "assets/gallery/image_28.jpeg";
import image29 from "assets/gallery/image_29.jpeg";
import image30 from "assets/gallery/image_30.jpeg";
import image31 from "assets/gallery/image_31.jpeg";
import image32 from "assets/gallery/image_32.jpeg";
import image33 from "assets/gallery/image_33.jpeg";
import image34 from "assets/gallery/image_34.jpeg";
import image35 from "assets/gallery/image_35.jpeg";
import image36 from "assets/gallery/image_36.jpeg";
import image37 from "assets/gallery/image_37.jpeg";
import image38 from "assets/gallery/image_38.jpeg";
import image39 from "assets/gallery/image_39.jpeg";
import image40 from "assets/gallery/image_40.jpeg";
import image41 from "assets/gallery/image_41.jpeg";
import image42 from "assets/gallery/image_42.jpeg";
import image43 from "assets/gallery/image_43.jpeg";
import image44 from "assets/gallery/image_44.jpeg";
import image45 from "assets/gallery/image_45.jpeg";
import image46 from "assets/gallery/image_46.jpeg";
import image47 from "assets/gallery/image_47.jpeg";
import image48 from "assets/gallery/image_48.jpeg";
import image49 from "assets/gallery/image_49.jpeg";
import image50 from "assets/gallery/image_50.jpeg";
import image51 from "assets/gallery/image_51.jpeg";
import image52 from "assets/gallery/image_52.jpeg";
import image53 from "assets/gallery/image_53.jpeg";
import image54 from "assets/gallery/image_54.jpeg";
import image55 from "assets/gallery/image_55.jpeg";
import image56 from "assets/gallery/image_56.jpeg";
import image57 from "assets/gallery/image_57.jpeg";
import image58 from "assets/gallery/image_58.jpeg";
import image59 from "assets/gallery/image_59.jpeg";
import image60 from "assets/gallery/image_60.jpeg";
import image61 from "assets/gallery/image_61.jpeg";
import image62 from "assets/gallery/image_62.jpeg";
import image63 from "assets/gallery/image_63.jpeg";
import image64 from "assets/gallery/image_64.jpeg";
import image65 from "assets/gallery/image_65.jpeg";
import image66 from "assets/gallery/image_66.jpeg";
import image67 from "assets/gallery/image_67.jpeg";
import image68 from "assets/gallery/image_68.jpeg";
import image69 from "assets/gallery/image_69.jpeg";
import image70 from "assets/gallery/image_70.jpeg";
import image71 from "assets/gallery/image_71.jpeg";
import image72 from "assets/gallery/image_72.jpeg";
import image73 from "assets/gallery/image_73.jpeg";
import image74 from "assets/gallery/image_74.jpeg";
import image75 from "assets/gallery/image_75.jpeg";
import image76 from "assets/gallery/image_76.jpeg";
import image77 from "assets/gallery/image_77.jpeg";
import image78 from "assets/gallery/image_78.jpeg";
import image79 from "assets/gallery/image_79.jpeg";
import image80 from "assets/gallery/image_80.jpeg";
import image81 from "assets/gallery/image_81.jpeg";
import image82 from "assets/gallery/image_82.jpeg";
import image83 from "assets/gallery/image_83.jpeg";
import image84 from "assets/gallery/image_84.jpeg";
import image85 from "assets/gallery/image_85.jpeg";
import image86 from "assets/gallery/image_86.jpeg";
import image87 from "assets/gallery/image_87.jpeg";
import image88 from "assets/gallery/image_88.jpeg";
import image89 from "assets/gallery/image_89.jpeg";
import image90 from "assets/gallery/image_90.jpeg";
import image91 from "assets/gallery/image_91.jpeg";
import image92 from "assets/gallery/image_92.jpeg";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.06 * i, duration: 0.45, ease: "easeOut" },
  }),
};

// --- Replace/extend these with your real images ---
const ITEMS = [
  {
    id: "img1",
    tag: "Gates",
    src: image1,
    thumb: image1,
    alt: " ",
  },
  {
    id: "img2",
    tag: "Gates",
    src: image2,
    thumb: image2,
    alt: " ",
  },
  {
    id: "img3",
    tag: "Gates",
    src: image3,
    thumb: image3,
    alt: " ",
  },
  {
    id: "img4",
    tag: "Gates",
    src: image4,
    thumb: image4,
    alt: " ",
  },
  {
    id: "img5",
    tag: "Gates",
    src: image5,
    thumb: image5,
    alt: " ",
  },
  {
    id: "img6",
    tag: "Gates",
    src: image6,
    thumb: image6,
    alt: " ",
  },
  {
    id: "img7",
    tag: "Gates",
    src: image7,
    thumb: image7,
    alt: " ",
  },
  {
    id: "img8",
    tag: "Gates",
    src: image8,
    thumb: image8,
    alt: " ",
  },
  {
    id: "img9",
    tag: "Gates",
    src: image9,
    thumb: image9,
    alt: " ",
  },
  {
    id: "img10",
    tag: "Gates",
    src: image10,
    thumb: image10,
    alt: " ",
  },
  {
    id: "img11",
    tag: "Gates",
    src: image11,
    thumb: image11,
    alt: " ",
  },
  {
    id: "img12",
    tag: "Gates",
    src: image12,
    thumb: image12,
    alt: " ",
  },
  {
    id: "img13",
    tag: "Gates",
    src: image13,
    thumb: image13,
    alt: " ",
  },
  {
    id: "img14",
    tag: "More",
    src: image14,
    thumb: image14,
    alt: " ",
  },
  {
    id: "img15",
    tag: "Gates",
    src: image15,
    thumb: image15,
    alt: " ",
  },
  {
    id: "img16",
    tag: "More",
    src: image16,
    thumb: image16,
    alt: " ",
  },
  {
    id: "img17",
    tag: "Windows",
    src: image17,
    thumb: image17,
    alt: " ",
  },
  {
    id: "img18",
    tag: "Windows",
    src: image18,
    thumb: image18,
    alt: " ",
  },
  // {
  //   id: "img19",
  //   tag: " ",
  //   src: image19,
  //   thumb: image19,
  //   alt: " ",
  // },
  {
    id: "img20",
    tag: "Windows",
    src: image20,
    thumb: image20,
    alt: " ",
  },
  {
    id: "img21",
    tag: "Water Tank Frames",
    src: image21,
    thumb: image21,
    alt: " ",
  },
  {
    id: "img22",
    tag: "More",
    src: image22,
    thumb: image22,
    alt: " ",
  },
  {
    id: "img23",
    tag: "Balcony Rails",
    src: image23,
    thumb: image23,
    alt: " ",
  },
  {
    id: "img24",
    tag: "Windows",
    src: image24,
    thumb: image24,
    alt: " ",
  },
  {
    id: "img25",
    tag: "Windows",
    src: image25,
    thumb: image25,
    alt: " ",
  },
  {
    id: "img26",
    tag: "Windows",
    src: image26,
    thumb: image26,
    alt: " ",
  },
  {
    id: "img27",
    tag: "Windows",
    src: image27,
    thumb: image27,
    alt: " ",
  },
  {
    id: "img28",
    tag: "Windows",
    src: image28,
    thumb: image28,
    alt: " ",
  },
  {
    id: "img29",
    tag: "Doors",
    src: image29,
    thumb: image29,
    alt: " ",
  },
  {
    id: "img30",
    tag: "Buglarproof",
    src: image30,
    thumb: image30,
    alt: " ",
  },
  {
    id: "img31",
    tag: "Doors",
    src: image31,
    thumb: image31,
    alt: " ",
  },
  {
    id: "img32",
    tag: "Doors",
    src: image32,
    thumb: image32,
    alt: " ",
  },
  {
    id: "img33",
    tag: "Doors",
    src: image33,
    thumb: image33,
    alt: " ",
  },
  {
    id: "img34",
    tag: "Doors",
    src: image34,
    thumb: image34,
    alt: " ",
  },
  {
    id: "img35",
    tag: "Doors",
    src: image35,
    thumb: image35,
    alt: " ",
  },
  {
    id: "img36",
    tag: "Doors",
    src: image36,
    thumb: image36,
    alt: " ",
  },
  {
    id: "img37",
    tag: "Doors",
    src: image37,
    thumb: image37,
    alt: " ",
  },
  {
    id: "img38",
    tag: "Windows",
    src: image38,
    thumb: image38,
    alt: " ",
  },
  {
    id: "img39",
    tag: "Windows",
    src: image39,
    thumb: image39,
    alt: " ",
  },
  {
    id: "img40",
    tag: "Windows",
    src: image40,
    thumb: image40,
    alt: " ",
  },
  {
    id: "img41",
    tag: "Windows",
    src: image41,
    thumb: image41,
    alt: " ",
  },
  {
    id: "img42",
    tag: "More",
    src: image42,
    thumb: image42,
    alt: " ",
  },
  {
    id: "img43",
    tag: "Doors",
    src: image43,
    thumb: image43,
    alt: " ",
  },
  {
    id: "img44",
    tag: "Doors",
    src: image44,
    thumb: image44,
    alt: " ",
  },
  {
    id: "img45",
    tag: "Chairs",
    src: image45,
    thumb: image45,
    alt: " ",
  },
  {
    id: "img46",
    tag: "Chairs",
    src: image46,
    thumb: image46,
    alt: " ",
  },
  {
    id: "img47",
    tag: "Tables",
    src: image47,
    thumb: image47,
    alt: " ",
  },
  {
    id: "img48",
    tag: "Buglarproof",
    src: image48,
    thumb: image48,
    alt: " ",
  },
  {
    id: "img49",
    tag: "Chairs",
    src: image49,
    thumb: image49,
    alt: " ",
  },
  // {
  //   id: "img50",
  //   tag: " ",
  //   src: image50,
  //   thumb: image50,
  //   alt: " ",
  // },
  {
    id: "img51",
    tag: "Chairs",
    src: image51,
    thumb: image51,
    alt: " ",
  },
  {
    id: "img52",
    tag: "Windows",
    src: image52,
    thumb: image52,
    alt: " ",
  },
  {
    id: "img53",
    tag: "Doors",
    src: image53,
    thumb: image53,
    alt: " ",
  },
  {
    id: "img54",
    tag: "Windows",
    src: image54,
    thumb: image54,
    alt: " ",
  },
  {
    id: "img55",
    tag: "Windows",
    src: image55,
    thumb: image55,
    alt: " ",
  },
  {
    id: "img56",
    tag: "Tables",
    src: image56,
    thumb: image56,
    alt: " ",
  },
  {
    id: "img57",
    tag: "Doors",
    src: image57,
    thumb: image57,
    alt: " ",
  },
  {
    id: "img58",
    tag: "Doors",
    src: image58,
    thumb: image58,
    alt: " ",
  },
  {
    id: "img59",
    tag: "Windows",
    src: image59,
    thumb: image59,
    alt: " ",
  },
  {
    id: "img60",
    tag: "Windows",
    src: image60,
    thumb: image60,
    alt: " ",
  },
  {
    id: "img61",
    tag: "Doors",
    src: image61,
    thumb: image61,
    alt: " ",
  },
  {
    id: "img62",
    tag: "Windows",
    src: image62,
    thumb: image62,
    alt: " ",
  },
  {
    id: "img63",
    tag: "Buglarproof",
    src: image63,
    thumb: image63,
    alt: " ",
  },
  {
    id: "img64",
    tag: "Buglarproof",
    src: image64,
    thumb: image64,
    alt: " ",
  },
  {
    id: "img65",
    tag: "Buglarproof",
    src: image65,
    thumb: image65,
    alt: " ",
  },
  {
    id: "img66",
    tag: "Buglarproof",
    src: image66,
    thumb: image66,
    alt: " ",
  },
  {
    id: "img67",
    tag: "Stairs & Rails",
    src: image67,
    thumb: image67,
    alt: " ",
  },
  {
    id: "img68",
    tag: "More",
    src: image68,
    thumb: image68,
    alt: " ",
  },
  {
    id: "img69",
    tag: "Windows",
    src: image69,
    thumb: image69,
    alt: " ",
  },
  {
    id: "img70",
    tag: " Buglarproof",
    src: image70,
    thumb: image70,
    alt: " ",
  },
  {
    id: "img71",
    tag: "Door Frames",
    src: image71,
    thumb: image71,
    alt: " ",
  },
  {
    id: "img72",
    tag: "Door Frames",
    src: image72,
    thumb: image72,
    alt: " ",
  },
  {
    id: "img73",
    tag: "Door Frames",
    src: image73,
    thumb: image73,
    alt: " ",
  },
  {
    id: "img74",
    tag: "Doors",
    src: image74,
    thumb: image74,
    alt: " ",
  },
  {
    id: "img75",
    tag: "Doors",
    src: image75,
    thumb: image75,
    alt: " ",
  },
  {
    id: "img76",
    tag: "Door Frames",
    src: image76,
    thumb: image76,
    alt: " ",
  },
  {
    id: "img77",
    tag: "Gates",
    src: image77,
    thumb: image77,
    alt: " ",
  },
  {
    id: "img78",
    tag: "Doors",
    src: image78,
    thumb: image78,
    alt: " ",
  },
  {
    id: "img79",
    tag: "Windows",
    src: image79,
    thumb: image79,
    alt: " ",
  },
  {
    id: "img80",
    tag: "Doors",
    src: image80,
    thumb: image80,
    alt: " ",
  },
  {
    id: "img81",
    tag: "Doors",
    src: image81,
    thumb: image81,
    alt: " ",
  },
  {
    id: "img82",
    tag: "Windows",
    src: image82,
    thumb: image82,
    alt: " ",
  },
  {
    id: "img83",
    tag: "Buglarproof",
    src: image83,
    thumb: image83,
    alt: " ",
  },
  {
    id: "img84",
    tag: "Curtains Brackets",
    src: image84,
    thumb: image84,
    alt: " ",
  },
  {
    id: "img85",
    tag: "Curtains Brackets",
    src: image85,
    thumb: image85,
    alt: " ",
  },
  {
    id: "img86",
    tag: "Balcony Rails",
    src: image86,
    thumb: image86,
    alt: " ",
  },
  {
    id: "img87",
    tag: "Doors",
    src: image87,
    thumb: image87,
    alt: " ",
  },
  {
    id: "img88",
    tag: "Windows",
    src: image88,
    thumb: image88,
    alt: " ",
  },
  {
    id: "img89",
    tag: "More",
    src: image89,
    thumb: image89,
    alt: " ",
  },
  {
    id: "img90",
    tag: "Tables",
    src: image90,
    thumb: image90,
    alt: " ",
  },
  {
    id: "img91",
    tag: "Windows",
    src: image91,
    thumb: image91,
    alt: " ",
  },
  {
    id: "img92",
    tag: "Tables",
    src: image92,
    thumb: image92,
    alt: " ",
  },
];

export function Gallery() {
  const [active, setActive] = useState("All");
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });

  const categories = useMemo(
    () => ["All", ...Array.from(new Set(ITEMS.map((i) => i.tag)))],
    [],
  );
  const filtered = useMemo(
    () => (active === "All" ? ITEMS : ITEMS.filter((i) => i.tag === active)),
    [active],
  );

  const openAt = useCallback((idx) => {
    setLightbox({ open: true, index: idx });
    // prevent background scroll
    document.documentElement.style.overflow = "hidden";
  }, []);

  const close = useCallback(() => {
    setLightbox({ open: false, index: 0 });
    document.documentElement.style.overflow = "";
  }, []);

  const prev = useCallback(() => {
    setLightbox((s) => ({
      ...s,
      index: (s.index - 1 + filtered.length) % filtered.length,
    }));
  }, [filtered.length]);

  const next = useCallback(() => {
    setLightbox((s) => ({ ...s, index: (s.index + 1) % filtered.length }));
  }, [filtered.length]);

  // Keyboard controls for lightbox
  useEffect(() => {
    if (!lightbox.open) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox.open, close, prev, next]);

  return (
    <WebLayout>
      {/* Header */}
      <section className="bg-gray-950">
        <div className="mx-auto max-w-7xl px-6 py-16 md:py-24">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            className="max-w-3xl"
          >
            <span className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-gray-300">
              Gallery
            </span>
            <h1 className="mt-4 text-4xl font-extrabold text-white md:text-5xl">
              Featured Projects
            </h1>
            <p className="mt-4 text-gray-300 md:text-lg">
              Explore selected work across doors, windows, burglarproofing,
              stairs &amp; railings, furniture, pagolas &amp; balconies,
              fittings, and tangstands.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters + Grid */}
      <section className="bg-gray-900">
        <div className="mx-auto max-w-7xl px-6 py-14 md:py-18">
          {/* Filters */}
          <div className="flex flex-wrap items-center gap-2">
            <div className="inline-flex items-center gap-2 text-white/70">
              <Grid size={16} />
              <span className="text-sm">Filter:</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map((c, i) => (
                <motion.button
                  key={c}
                  type="button"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={fadeUp}
                  custom={i}
                  onClick={() => setActive(c)}
                  className={`rounded-full border px-3 py-1 text-sm transition
                    ${
                      active === c
                        ? "border-green-500/40 bg-green-500/10 text-green-400"
                        : "border-white/10 bg-white/5 text-white hover:bg-white/10"
                    }
                  `}
                >
                  {c}
                </motion.button>
              ))}
            </div>
          </div>

          {/* Grid */}
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((item, i) => (
              <motion.figure
                key={item.id}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeUp}
                custom={i}
                className="group relative overflow-hidden rounded-2xl border border-white/10"
              >
                <button
                  type="button"
                  onClick={() => openAt(i)}
                  className="block w-full text-left"
                  aria-label={`Open ${item.tag} image`}
                >
                  <img
                    src={item.thumb || item.src}
                    alt={item.alt}
                    loading="lazy"
                    className="h-60 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-transparent" />
                  <figcaption className="absolute left-3 bottom-3 rounded-md bg-black/50 px-2 py-1 text-xs font-semibold text-white backdrop-blur">
                    {item.tag}
                  </figcaption>
                </button>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox.open && filtered[lightbox.index] && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          onClick={close}
        >
          <div
            className="relative max-h-[90vh] w-full max-w-5xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={filtered[lightbox.index].src}
              alt={filtered[lightbox.index].alt}
              className="mx-auto max-h-[80vh] w-auto rounded-lg object-contain"
            />

            {/* Controls */}
            <button
              onClick={close}
              aria-label="Close"
              className="absolute right-3 top-3 rounded-md bg-black/60 p-2 text-white hover:bg-black/80"
            >
              <X size={18} />
            </button>
            {filtered.length > 1 && (
              <>
                <button
                  onClick={prev}
                  aria-label="Previous"
                  className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/60 p-2 text-white hover:bg-black/80"
                >
                  <ChevronLeft size={22} />
                </button>
                <button
                  onClick={next}
                  aria-label="Next"
                  className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/60 p-2 text-white hover:bg-black/80"
                >
                  <ChevronRight size={22} />
                </button>
              </>
            )}

            {/* Counter */}
            <div className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 rounded-md bg-black/50 px-2 py-1 text-xs text-white">
              {lightbox.index + 1} / {filtered.length}
            </div>
          </div>
        </div>
      )}
    </WebLayout>
  );
}
